<template>
    <section id="Find_Near_By_Clients" class="d-flex flex-grow-1">
        <div class="w-25 ps-2 pt-2 bg-white d-flex flex-column position-relative">
            <div class="d-flex align-items-center justify-content-between mb-1 pe-2">
                <h6 class="fw-bold m-0">Employee Proximity</h6>
                <div>
                    <button class="btn text-primary fw-bold p-0 me-3" @click="clearNearbyClientFilters()">Clear</button>
                    <button class="btn text-primary fw-bold p-0" @click="closeNearbyClientPanel()">Done</button>
                </div>
            </div>
            <div class="ai-line"></div>
            <section class="pe-2">
                <div class="row my-2">
                    <div class="col-4 pe-0">
                        <div class="form-control border-0 text-dark"><strong>Search</strong></div>
                    </div>
                    <div class="col-8 ps-0">
                        <div class="">
                            <input class="form-control" placeholder="Search by Name" v-model="nearbyClientSearchTerm" />
                        </div>
                    </div>
                </div>
                <div class="row my-2">
                    <div class="col-4 pe-0">
                        <div class="form-control border-0 text-dark"><strong>Distance</strong></div>
                    </div>
                    <div class="col-8 ps-0">
                        <div class="">
                            <select class="form-select" v-model="nearbyClientDistance">
                                <option :value="5">5 miles</option>
                                <option :value="10">10 miles</option>
                                <option :value="15">15 miles</option>
                                <option :value="20">20 miles</option>
                                <option :value="25">25 miles</option>
                            </select>
                        </div>
                    </div>
                </div>
            </section>

            <section :class="`nearby-emp-list pe-1 ${userOs == 'Windows' ? 'custom-scrollbar' : ''}`">
                <div
                    v-for="clientPanel of nearbyClientPanelList"
                    :key="clientPanel.PatientDetails.Id"
                    :class="`nearby-emp-card mb-2 ${selectedNearbyClient.Id === clientPanel.PatientDetails.Id ? 'selected' : ''}`"
                    @click="highlightClientPin(clientPanel.PatientDetails, clientPanel.PatientDetails.Id)"
                >
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="fw-bold text-break">
                            {{ clientPanel.PatientDetails.LastName }} {{ clientPanel.PatientDetails.FirstName }}
                        </div>
                        <button
                            type="button"
                            class="btn px-1 py-0  ms-1 btn-outline-primary icon-size align-self-start"
                            data-bs-toggle="dropdown"
                            :id="`client__actions${clientPanel.PatientDetails.Id}`"
                        >
                            <i class="fas fa-ellipsis-h icon-size"></i>
                        </button>
                        <div class="dropdown-menu" :aria-labelledby="`client__Actions${clientPanel.PatientDetails.Id}`">
                            <a
                                class="dropdown-item"
                                :id="`add-task-${clientPanel.PatientDetails.Id}`"
                                href="javascript:void(0);"
                                @click="scheduleVisit(clientPanel.PatientDetails)"
                            >
                                Add Task
                            </a>
                        </div>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <small class="d-flex align-items-center" v-if="clientPanel.PatientDetails?.PhoneNumber">
                            <i class="fas fa-mobile text-primary me-1"></i>
                            <a :href="'tel:' + clientPanel.PatientDetails?.PhoneNumber">
                                {{ formatPhone(clientPanel.PatientDetails?.PhoneNumber) }}
                            </a>
                        </small>
                        <small class="text-muted">{{ clientPanel.PatientDetails.Distance }} miles away</small>
                    </div>
                    <small
                        class="d-flex align-items-center"
                        v-if="clientPanel.PatientDetails?.AddressLine1 || clientPanel.PatientDetails?.AddressLine2"
                    >
                        <i class="fas fa-map-marker text-primary me-1"></i>
                        <address class="mb-0">
                            {{ clientPanel.PatientDetails?.AddressLine1 }}
                            {{ clientPanel.PatientDetails?.AddressLine2 }}
                        </address>
                    </small>
                    <div class="d-flex flex-wrap align-items-center mb-1">
                        <ProductPill
                            class="me-2"
                            :product-id="getApplicationId(clientPanel.PatientDetails.Application)"
                        />
                        <div
                            :class="`me-2 pill text-capitalize ${getStatusPillClass(clientPanel.PatientDetails.Status).toLowerCase()}`"
                        >
                            {{ getStatusText(clientPanel.PatientDetails.Status) }}
                        </div>
                        <small class="text-muted fw-bold">{{ clientPanel.PatientDetails.AgencyName }}</small>
                    </div>
                </div>
                <div class="text-center py-2" ref="trigger" v-show="pageCount < totalPageCount && showLoading">
                    <i class="fas fa-spinner fa-pulse fa-fw fa-2x"></i>
                    <div>Loading...</div>
                </div>
                <div class="text-center py-2" v-if="pageCount >= totalPageCount && nearbyClientPanelList.length">
                    Showing {{ totalItemCount }} Patients
                </div>
                <div v-if="!nearbyClientPanelList.length && !showLoading" class="nearby-emp-list pe-1">
                    No patients found
                </div>
            </section>
            <!-- Premium will come later -->
            <!-- <div class="d-flex justify-content-end">
                <img class="pe-2" src="../../../../../../img/Axxess_Intelligence_logo_2.svg" alt="" />
                <button class="ai-premium-btn mx-2 mt-2 mb-1">Premium</button>
            </div>
            <div class="ai-line"></div> -->
        </div>

        <div class="flex-grow-1" id="NearbyClient__VisitMap"></div>
    </section>
</template>

<script lang="ts" src="./FindNearbyClients.ts"></script>
<style lang="scss" src="./FindNearbyClients.scss"></style>
